import React, { Suspense, useContext, useEffect, useState, useRef } from 'react';
import { useMatch, Outlet } from 'react-router-dom';
import "../../index.css";
import "../../App.scss";
import Headers from "./Header";
import Sidemenu from "./Sider";
import { Layout, FloatButton, message } from 'antd';
import { COOKIE, getCookie } from '../../Services/Cookie';
import { fetchApi } from '../../Services/Api';
import { isArray } from 'highcharts';
import constants from '../../Constants/constants';
import { loadSession } from '../../GlobalFunctions/GlobalFunctions';
import { Spinner } from 'react-bootstrap';
import ContactUsWithFloater from '../Common/Floater'; 
import { UserContext } from '../../Context';
import ScrollToTop from './ScrollToTop';

const capitalizeFirstLetter = (str) => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};

function uppercaseWordInString(string, targetWord) {
  const words = string.split(' ');
  for (let i = 0; i < words.length; i++) {
    if (words[i].toLowerCase() === targetWord.toLowerCase()) {
      words[i] = words[i].toUpperCase();
    } else {
      words[i] = capitalizeFirstLetter(words[i]);
    }
  }
  return words.join(' ');
}

const Layouts = () => {
  const scrollRef = useRef(null);
  const { setProfileImage, setSession } = useContext(UserContext);
  const match = useMatch('/:page'); // Adjust the route pattern as needed
  const userType = getCookie(COOKIE.UserId);
  const [data, setData] = useState([]);
  const [maxYear, setMaxYear] = useState(0);
  // Nothing below renders until the session is fetched -- the screens read their
  // permissions from it during render.
  const [sessionReady, setSessionReady] = useState(false);

  useEffect(() => {
    if (match) {
      const pageTitle = match.params.page.replace(/-/g, ' '); // Replace "-" with space
      const gpaWordExists = pageTitle.includes('gpa');
      const slpWordExists = pageTitle.includes('slp');
      const formattedTitle = gpaWordExists ? uppercaseWordInString(pageTitle, 'gpa') : slpWordExists ? uppercaseWordInString(pageTitle, 'slp') : capitalizeFirstLetter(pageTitle);
      document.title = `${formattedTitle} | Clin-Ed`;
    }
  }, [match]);

  useEffect(() => {
    let cancelled = false;
    // Render on settle, not on success: a timed out call should not leave a
    // spinner that never clears.
    const settle = (session) => {
      if (cancelled) return;
      setSessionReady(true);
      if (session) {
        setSession(session);
        setProfileImage(session.profileImage || '');
        notificationsList();
        getMaxYear();
      }
    };
    loadSession().then(settle).catch(() => settle(null));
    return () => { cancelled = true; };
  }, []);

  const getMaxYear = () => {
    const currentMaxYear = constants.StudentYearList[constants.StudentYearList.length - 1].id;
    fetchApi(`/get-max-year`, "GET").then((res) => {
      if (res?.code === "200") {
        setMaxYear(res?.data?.max_year || currentMaxYear);
      } else setMaxYear(currentMaxYear)
    }).catch(() => {
      setMaxYear(currentMaxYear)
    });
  }

  const notificationsList = () => {
    const payload = { isFaculty: userType };
    fetchApi(`/get-all-notifications`, "POST", payload).then((res) => {
      if (res?.code === "200") {
        if (isArray(res?.data) && res?.data?.length > 0) {
          setData(res?.data);
          return
        }
      }
      setData([]);
    }).catch(() => {});
  };

  const updateNotificationData = () => {
    notificationsList();
  };

  const notificationCount = data?.length;

  const fallback = () => (
    <div className="mx-auto min-vh-100 d-flex justify-content-center align-items-center p-3 p-md-0">
      <Spinner animation="border" role="output" className="d-flex justify-content-center align-items-center position-absolute z-3"></Spinner>
    </div>
  )

  if (!sessionReady) return fallback();

  return (
    <Layout>
      <Sidemenu notificationCount={notificationCount} />
      <Layout>
        <Headers countData={data} />
        <Suspense fallback={fallback()}>
          <ScrollToTop targetRef={scrollRef} />
          <div ref={scrollRef} className="h-[calc(100vh-50px)] p-3 overflow-y-auto">
            <Outlet context={[data, updateNotificationData, maxYear, getMaxYear]} />
            <FloatButton.Group shape="circle" style={{ insetInlineEnd: 24 }}>
              <FloatButton.BackTop className='right-2.5 top-btn' type='primary' visibilityHeight={100} target={() => scrollRef.current} />
              <ContactUsWithFloater />
            </FloatButton.Group>
          </div>
        </Suspense>
      </Layout>
    </Layout>
  );
};
export default Layouts;